export default {
  auth: {
    isLogged: false,
    user: {
      code: null,
      codeCustomer: null,
      credentials: null,
      crm: null,
      customer: null,
      customerName: null,
      id: null,
      name: null,
      state: null,
      token: null,
      username: null
    },
    myClinic: {
      code: null,
      codeCustomer: null,
      crm: null,
      customer: null,
      customerName: null,
      id: null,
      name: null,
      state: null
    },
    account: {},
    profile: {}
  },
  customers: [],
  token: {},
  register: [],
  recoveryPassword: null,
  refreshToken: null,
  searchRegisterUser: []
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js